// Lógica pura de la sección de filtros del constructor de reportes.
// Espejo del catálogo FILTROS del backend (app/services/report_builder.py):
// mismos campos, fuentes compatibles y operadores permitidos. Las filas de UI
// se convierten a objetos Filtro del backend derivando el operador =/in de la
// cantidad de valores; el backend valida todo de nuevo (whitelist).

export const CATALOGO_FILTROS = {
  bodega: { label: "Bodega", fuentes: "*", tipo: "multi" },
  articulo: { label: "Artículo (códigos, coma)", fuentes: "*", tipo: "texto" },
  clasificador: { label: "Clasificador", fuentes: "*", tipo: "multi" },
  clasificacion_rotacion: {
    label: "Clasif. rotación", fuentes: "inventario", tipo: "multi",
    opciones: ["ganador", "normal", "perdedor"],
  },
  dias_sin_venta: { label: "Días sin venta", fuentes: "inventario", tipo: "numero" },
};

export function camposParaFuente(fuente) {
  return Object.keys(CATALOGO_FILTROS).filter(c => {
    const f = CATALOGO_FILTROS[c].fuentes;
    return f === "*" || f === fuente;
  });
}

// fila de UI -> Filtro del backend; null si la fila está vacía o inválida
export function filaAFiltro(fila) {
  const def = CATALOGO_FILTROS[fila.campo];
  const tipo = fila.degradado || !def ? "texto" : def.tipo;

  if (tipo === "numero") {
    const n = Number(fila.texto);
    if (fila.texto === "" || fila.texto == null || Number.isNaN(n)) return null;
    return { campo: fila.campo, operador: fila.operador || ">=", valor: n };
  }

  const valores = tipo === "multi"
    ? (fila.valores || [])
    : String(fila.texto || "").split(",").map(s => s.trim()).filter(Boolean);
  if (valores.length === 0) return null;
  if (valores.length === 1) return { campo: fila.campo, operador: "=", valor: valores[0] };
  return { campo: fila.campo, operador: "in", valor: valores };
}

// Filtro guardado -> fila de UI (para poblar el constructor al cargar un reporte)
export function filtroAFila(filtro) {
  const def = CATALOGO_FILTROS[filtro.campo];
  const lista = Array.isArray(filtro.valor) ? filtro.valor.map(String) : [String(filtro.valor)];

  if (!def) return { campo: filtro.campo, degradado: true, texto: lista.join(", ") };
  if (def.tipo === "numero") return { campo: filtro.campo, operador: filtro.operador, texto: String(filtro.valor) };
  if (def.tipo === "texto") return { campo: filtro.campo, texto: lista.join(", ") };
  return { campo: filtro.campo, valores: lista };
}

// filas de UI -> filtros listos para enviar (descarta filas vacías/incompletas)
export function podarFiltros(filas) {
  return filas.map(filaAFiltro).filter(Boolean);
}
